import { createApi } from "@reduxjs/toolkit/query/react";
import { AccountInfo } from "@azure/msal-browser";
import { accountBaseQuery } from "config/api.config";

export const accountApi = createApi({
  reducerPath: "account",
  baseQuery: accountBaseQuery,
  endpoints: (builder) => ({
    getUserInfo: builder.query<AccountInfo, void>({
      query: () => "me",
    }),
  }),
});

export const { useGetUserInfoQuery } = accountApi;
